import { useEffect, useRef } from "react"

export type SwipeProps = {
	onSwipe: ({
		dirX,
		dirY,
		deltaTime,
		startX,
		startY,
	}: {
		dirX: number
		dirY: number
		deltaTime: number
		startX: number
		startY: number
	}) => void
}

export function Swipe({ onSwipe }: SwipeProps) {
	const dataRef = useRef({
		startX: 0,
		startY: 0,
		startTime: 0,
	})

	useEffect(() => {
		if (!onSwipe) return

		const handleTouchStart = (e) => {
			const touch = e.changedTouches[0]
			dataRef.current.startX = touch.clientX
			dataRef.current.startY = touch.clientY
			dataRef.current.startTime = Date.now()
		}

		const handleTouchEnd = (e) => {
			const touch = e.changedTouches[0]
			const dirX = touch.clientX - dataRef.current.startX
			const dirY = touch.clientY - dataRef.current.startY

			onSwipe({
				dirX,
				dirY,
				deltaTime: Date.now() - dataRef.current.startTime,
				startX: dataRef.current.startX,
				startY: dataRef.current.startY,
			})
		}

		document.addEventListener("touchstart", handleTouchStart)
		document.addEventListener("touchend", handleTouchEnd)

		return () => {
			document.removeEventListener("touchstart", handleTouchStart)
			document.removeEventListener("touchend", handleTouchEnd)
		}
	}, [onSwipe])

	return null
}
